import { render, staticRenderFns } from "./ShopCaseTable.vue?vue&type=template&id=164a287b&scoped=true&"
import script from "./ShopCaseTable.vue?vue&type=script&lang=js&"
export * from "./ShopCaseTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopCaseTable.vue?vue&type=style&index=0&id=164a287b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a287b",
  null
  
)

export default component.exports